<template>
  <div style="width: 100%; height: 100%" class="ma-0 pa-0 box-container">
    <v-row class="ma-1 pa-0 row-header">
      <t-button v-if="editMode || currentMaintenanceSchedule != null" :elevation="5" :class="'ma-2'" btnIcon="mdi-plus-circle" :btnText="'Нов график'" :width="'180'" style="display: flex; cursor: pointer" @click.native="addSchedule()"> </t-button>
      <t-button v-if="!editMode && currentMaintenanceSchedule == null" :elevation="5" :class="'ma-2'" btnIcon="mdi-pencil" btnText="Редакция" :width="'180'" style="display: flex; cursor: pointer" @click.native="editMode = !editMode"> </t-button>
      <t-button v-if="editMode || currentMaintenanceSchedule != null" :elevation="5" :class="'ma-2'" btnIcon="mdi-checkbox-marked-circle-outline" btnText="Запази" :width="'180'" style="display: flex; cursor: pointer" @click.native="saveSchedule()"> </t-button>
    </v-row>
    <v-row class="ma-1 pa-0 row-content">
      <v-simple-table style="background: none" :fixed-header="true">
        <thead style="background: none">
          <tr :style="isInDarkMode ? 'background: #333' : 'background: #FFF'">
            <th v-for="day in weekDays" :key="day" :style="isOnMobile ? 'min-width: 30px;' : 'min-width: 100px;'" class="v-data-table__divider">
              <div class="d-flex justify-center">{{ day }}</div>
            </th>
            <th v-if="currentMaintenanceSchedule != null || editMode" class="v-data-table__divider"></th>
          </tr>
        </thead>
        <tbody style="background: none">
          <template v-for="(schedule, id) in maintenanceSchedules">
            <tr :key="'trrr' + id" :style="isInDarkMode ? 'background: #333' : 'background: #FFF'">
              <td v-for="day in weekDays" :key="day" :style="(isOnMobile ? 'min-width: 30px;' : 'min-width: 100px;') + (isInDarkMode ? 'background: #333' : 'background: #FFF')" class="v-data-table__divider">
                <div class="d-flex justify-center">
                  <v-checkbox v-if="currentMaintenanceSchedule == id || editMode" :input-value="schedule.includes(day)" @change="addRemoveDay(schedule, day)"></v-checkbox>
                  <span v-else style="font-size: 1.4em">
                    {{ schedule.includes(day) ? "✓" : "" }}
                  </span>
                </div>
              </td>
              <td class="v-data-table__divider" v-if="currentMaintenanceSchedule != null || editMode">
                <div class="d-flex justify-center">
                  <!-- <TooltipButton
                    v-if="currentMaintenanceSchedule == id"
                    btnColor="success"
                    btnText="Запази"
                    btnIcon="mdi-content-save-edit"
                    @click="currentMaintenanceSchedule = null"
                  />
                  <TooltipButton
                    v-else
                    btnColor="success"
                    btnText="Редакция"
                    btnIcon="mdi-pencil"
                    @click="editSchedule(id)"
                  /> -->
                  <TooltipButton v-if="currentMaintenanceSchedule == id || editMode" btnColor="error" btnText="Премахване" btnIcon="mdi-window-close" @click="deleteSchedule(id)" />
                </div>
              </td>
            </tr>
            <tr :key="'id' + id" :style="isInDarkMode ? 'background: #333' : 'background: #FFF'">
              <td colspan="8" :style="isInDarkMode ? 'background: #333' : 'background: #FFF'">
                <div class="d-flex pl-3">
                  <TooltipButton
                    :class="'pr-4'"
                    :color="Colors.IconColor"
                    :btnText="currentMaintenanceSchedule == id || editMode ? 'Избор на устройства' : 'ФУВАС с този график'"
                    :btnImg="TremolVIcon"
                    @click="currentMaintenanceSchedule == id || editMode ? pickDevices(id) : ''"
                  />
                  <span v-if="getDevs(id)" style="display: inline-flex; align-items: center; vertical-align: middle; overflow: word-wrap">{{ getDevs(id) }}</span>
                  <span v-else style="display: inline-flex; align-items: center; vertical-align: middle; overflow: word-wrap">Няма избрани ФУВАС за този график </span>
                </div>
              </td>
            </tr>
            <tr :key="'idd' + id">
              <td :colspan="currentMaintenanceSchedule != null || editMode ? 8 : 7" style="height: 10px"></td>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </v-row>
  </div>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
export default {
  data() {
    return {
      editMode: false,
      devs: [],
      maintenanceDialog: false,
      currentMaintenanceSchedule: null,
      maintenanceSchedules: [],
      daysShort: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Нд"],
      daysLong: ["Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота", "Неделя"],
    };
  },
  computed: {
    weekDays() {
      return this.isOnMobile ? this.daysShort : this.daysLong;
    },
  },
  methods: {
    addSchedule() {
      let id = this.maintenanceSchedules.length;
      this.maintenanceSchedules.push([]);
      this.currentMaintenanceSchedule = id;

      //   this.editSchedule(idx);
    },
    addRemoveDay(schedule, dd) {
      var dayz = this.isOnMobile ? DataManager.WeekDaysShort : DataManager.WeekDays;
      var day = DataManager.WeekDays[dayz.indexOf(dd)];
      if (schedule.includes(day)) schedule.splice(schedule.indexOf(day), 1);
      else schedule.splice(this.daysLong.indexOf(dd), 0, day);
      schedule.filter((s) => DataManager.WeekDays.indexOf(s) == -1).forEach((s) => schedule.splice(schedule.indexOf(s), 1));
    },
    editSchedule(id) {
      this.currentMaintenanceSchedule = id;
    },
    saveSchedule() {
      var devsWChangedSched = DataManager.getData(DataManager.DataType.devices, true).filter((d) => d.IsFuvas && !d.IsOldFuvas && this.devs.find((dd) => dd.id == d.id && dd.MaintenanceScheduleId != d.MaintenanceScheduleId));
      devsWChangedSched.forEach((d) => {
        var dev = this.devs.find((dd) => dd.id == d.id);
        if (dev && dev.MaintenanceScheduleId != null) {
          d.MaintenanceScheduleId = dev.MaintenanceScheduleId;
        } else {
          d.MaintenanceScheduleId = null;
        }
      });
      DataManager.updateUserSettings(null, DataManager.getData(DataManager.DataType.user, true).settings2, null, null, null, (err2) => {
        if (err2.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          DataManager.updateDevProfile(devsWChangedSched, (err) => {
            if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
              this.dialogLoader.showInfo("Успешен запис на графиците за обслужване.");
              this.reloadData();
              this.isDirty = false;
              this.editMode = false;
              this.currentMaintenanceSchedule = null;
            } else {
              this.dialogLoader.showError("Грешка при запис на график за обслужване!\n" + err.toString());
            }
          });
        } else {
          this.dialogLoader.showError("Грешка при запис на одит графици!\n" + err2.toString());
        }
      });
    },
    deleteSchedule(id) {
      this.dialog.show(
        "yes-no",
        null,
        {
          title: "Внимание",
          buttonYesText: "Да",
          buttonNoText: "Не",
          text: "Сигурни ли сте, че искате да премахнете графика?",
        },
        (result) => {
          if (result) {
            this.devs
              .filter((d) => d.MaintenanceScheduleId != null)
              .forEach((d) => {
                if (d.MaintenanceScheduleId == id) {
                  d.MaintenanceScheduleId = null;
                } else if (d.MaintenanceScheduleId > id) {
                  d.MaintenanceScheduleId = d.MaintenanceScheduleId - 1;
                }
              });
            this.maintenanceSchedules.splice(id, 1);
            this.isDirty = true;
          }
        }
      );
    },
    getDevs(idx) {
      return this.devs
        .filter((d) => !this.reload && d.MaintenanceScheduleId == idx)
        .map((d) => d.Name)
        .join(", ");
    },
    reloadData() {
      this.devs = DataManager.getData(DataManager.DataType.devices, true)
        .filter((i) => i.IsFuvas && !i.IsOldFuvas)
        .map((d) => ({
          id: d.id,
          Name: d.Name,
          MaintenanceScheduleId: d.MaintenanceScheduleId,
        }));
      this.maintenanceSchedules = DataManager.getData(DataManager.DataType.user, true).settings2.maintenanceschedules;
      this.maintenanceSchedules.forEach((sch) =>
        sch.sort((a, b) => {
          return this.daysLong.indexOf(a) - this.daysLong.indexOf(b);
        })
      );
    },
    pickDevices(idx) {
      this.dialog.show(
        "picker-view",
        this.devs,
        {
          title: "Избор на ФУВАС за график: " + this.maintenanceSchedules[idx].join(", "),
          multiple: true,
          allowEmpty: true,
          toStringFn: (i) => {
            // return i.Name;
            return i.Name + (i.MaintenanceScheduleId != null ? " (" + this.maintenanceSchedules[i.MaintenanceScheduleId].join(", ") + ")" : "");
          },
          selected: this.devs.filter((d) => d.MaintenanceScheduleId == idx),
          buttonCancelText: "Откажи",
          buttonOKText: "Запази",
        },
        (result) => {
          if (result != null) {
            this.isDirty = true;
            this.devs.forEach((d) => {
              if (result.indexOf(d) != -1) {
                d.MaintenanceScheduleId = idx;
              } else if (d.MaintenanceScheduleId == idx) {
                d.MaintenanceScheduleId = null;
              }
            });
          }
        }
      );
    },
  },
  mounted() {
    this.reloadData();
  },
};
</script>

<style scoped>
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
